import script from "./StudentAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./StudentAnalysis.vue?vue&type=style&index=0&id=32be57a9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32be57a9"]])

export default __exports__